// Common
import commonIconUsername from '~/assets/icons/common_icon_username.svg';
import commonIconPassword from '~/assets/icons/common_icon_password.svg';
import commonIconShowPassword from '~/assets/icons/common_icon_show_password.svg';
import commonIconHidePassword from '~/assets/icons/common_icon_hide_password.svg';
import commonIconEnglishFlag from '~/assets/icons/common_icon_english_flag.svg';
import commonIconItalianFlag from '~/assets/icons/common_icon_italian_flag.svg';
import commonIconSpainFlag from '~/assets/icons/common_icon_spain_flag.svg';
import commonIconChangeStatusActive from '~/assets/icons/common_icon_change_status_active.svg';
import commonIconChangeStatusInactive from '~/assets/icons/common_icon_change_status_inactive.svg';
import commonIconAnnouncement from '~/assets/icons/common_icon_announcement.svg';
import commonIconCalendarDay from '~/assets/icons/common_icon_calendar_day.svg';
import commonIconTeacher from '~/assets/icons/common_icon_teacher.svg';
import commonIconClock from '~/assets/icons/common_icon_clock.svg';
import commonIconMenuMobile from '~/assets/icons/common_icon_menu_mobile.svg';
import commonIconClose from '~/assets/icons/common_icon_close.svg';
import commonIconChangeLanguage from '~/assets/icons/common_icon_change_language.svg';
import commonIconHelp from '~/assets/icons/common_icon_help.svg';
import commonIconUploadFile from '~/assets/icons/common_icon_upload_file.svg';
import commonIconImageDefault from '~/assets/icons/common_icon_image_default.svg';
import commonIconTuitionFees from '~/assets/icons/common_icon_tuition_fees.svg';
import commonIconDownloadPdf from '~/assets/icons/common_icon_download_pdf.svg';
import commonIconTuitionArea from '~/assets/icons/common_icon_tuition_area.svg';
import commonIconTuitionAreaMobile from '~/assets/icons/common_icon_tuition_area_mobile.svg';
import commonIconExamArea from '~/assets/icons/common_icon_exam_area.svg';
import commonIconExamAreaMobile from '~/assets/icons/common_icon_exam_area_mobile.svg';
import commonIconStatusFailed from '~/assets/icons/common_icon_status_failed.svg';
import commonIconBack from '~/assets/icons/common_icon_back.svg';
import commonIconLink from '~/assets/icons/common_icon_link.svg';
import commonIconCourse from '~/assets/icons/common_icon_course.png';
import commonIconStudent from '~/assets/icons/common_icon_student.png';
import commonIconSendEmail from '~/assets/icons/common_icon_send_email.svg';

const icons = {
  // Common
  commonIconUsername,
  commonIconPassword,
  commonIconShowPassword,
  commonIconHidePassword,
  commonIconEnglishFlag,
  commonIconItalianFlag,
  commonIconSpainFlag,
  commonIconChangeStatusActive,
  commonIconChangeStatusInactive,
  commonIconAnnouncement,
  commonIconCalendarDay,
  commonIconTeacher,
  commonIconClock,
  commonIconMenuMobile,
  commonIconClose,
  commonIconChangeLanguage,
  commonIconHelp,
  commonIconUploadFile,
  commonIconExamArea,
  commonIconExamAreaMobile,
  commonIconImageDefault,
  commonIconTuitionFees,
  commonIconStatusFailed,
  commonIconDownloadPdf,
  commonIconTuitionArea,
  commonIconTuitionAreaMobile,
  commonIconBack,
  commonIconLink,
  commonIconCourse,
  commonIconStudent,
  commonIconSendEmail,
};

export default icons;
